import React from "react";

const weeks = [1,2,3,4];

const WeekTabs = ({ activeWeek, setActiveWeek }) => {

  return (

    <div className="flex gap-2 mb-4">

      {weeks.map((week) => (

        <button
          key={week}
          onClick={() => setActiveWeek(week)}
          className={`px-4 py-2 rounded-lg text-sm
          ${activeWeek === week
            ? "bg-blue-600 text-white"
            : "bg-gray-100"
          }`}
        >
          Week {week}
        </button>

      ))}

    </div>

  );

};

export default WeekTabs;